import React, {useEffect, useRef, useState} from 'react';
import RouterPath from "libs/RouterPath";
import Tr from "translations/Translations";
import ExpansionProgressPanel from "./ExpansionProgressPanel";
import RfxOfferService from "services/RfxOfferService";
import {connect} from "react-redux";
import {Typography} from "@material-ui/core";
import ProgressStatus from "../../../../../../constants/ProgressStatus";

const OfferDecryptionProgress = (
    {
        demandId,
        roundId,
        rfxOfferDecryptionStatus
    }) => {
    const [progress, setProgress] = useState([0, 0]);
    const [working, setWorking] = useState(false);
    const progressInterval = useRef(0);
    const statusInterval = useRef(0);

    useEffect(() => {

        RfxOfferService.getOffersDecryptionStatus(roundId).then(resp => {
            if (resp.status === ProgressStatus.IN_PROGRESS) {
                startProgressInterval();
            }

            if (resp.status === ProgressStatus.PROCESSED) {
                setProgress([100, 0]);
            }
        });

        return () => {
            if (progressInterval.current) clearInterval(progressInterval.current);
            if (statusInterval.current) clearInterval(statusInterval.current);
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {

        if (ProgressStatus.PROCESSED === rfxOfferDecryptionStatus.status) {
            const rp = RouterPath.myProcedure;
            RouterPath.redirect(RouterPath.createPath(rp.steps.MP_3_ID, {id: demandId}))
        }

    }, [rfxOfferDecryptionStatus, demandId])

    const startProgressInterval = () => {

        progressInterval.current = setInterval(async () => {
            const resp = await RfxOfferService.getOffersDecryptionProgress(roundId);
            setProgress(resp.result);
            if (resp.result[0] === 100) {
                clearInterval(progressInterval.current);
                progressInterval.current = 0;
                startOfferDecryptionStatusInterval();
            }

        }, 3000);
    };

    const startOfferDecryptionStatusInterval = () => {
        statusInterval.current = setInterval(async () => {
            const resp = RfxOfferService.getOffersDecryptionStatus(roundId);
            if (resp.status === ProgressStatus.PROCESSED) {
                clearInterval(statusInterval.current);
                statusInterval.current = 0;
            }
        }, 3000);
    };

    const onDecryptionStart = () => {
        setWorking(true);
        RfxOfferService.startOffersDecryptionProcess(roundId)
            .then(() => {
                RfxOfferService.getOffersDecryptionStatus(roundId).then(() => startProgressInterval());
            });
    };

    const openOffers = () => {
        RfxOfferService.startOffersDecryptionProcess(roundId)
            .then(() => {
                const rp = RouterPath.myProcedure;
                RouterPath.redirect(RouterPath.createPath(rp.steps.MP_3_ID, {id: demandId}));
            });
    }

    const getDetails = () => {
            if (rfxOfferDecryptionStatus?.errors?.length) {
                return <><div>
                    {rfxOfferDecryptionStatus.errors.map(x => {
                            return <Typography key={x} color='error'>{Tr(x)}</Typography>
                        }
                    )}
                </div>
                </>
            }
            if (rfxOfferDecryptionStatus?.warnings?.length) {
                return <><div>
                    {rfxOfferDecryptionStatus.warnings.map(x => {
                            return <Typography key={x} color='textSecondary'>{Tr(x)}</Typography>
                        }
                    )}
                </div>
                </>
            }
    };

    return (
        <>
            <ExpansionProgressPanel
                buttonText={Tr('open_offers')}
                title={rfxOfferDecryptionStatus.decryptionEnabled ? Tr('decrypt_open_offers') : Tr('open_offers')}
                progress={progress[0]} queue={progress[1]} showProgress={rfxOfferDecryptionStatus.decryptionEnabled && rfxOfferDecryptionStatus.status === ProgressStatus.IN_PROGRESS}
                buttonDisabled={working || !rfxOfferDecryptionStatus.editable || rfxOfferDecryptionStatus.status !== ProgressStatus.CAN_START}
                onButtonClick={rfxOfferDecryptionStatus.decryptionEnabled ? onDecryptionStart : openOffers}
                optional={!rfxOfferDecryptionStatus.required}
                details={getDetails()}
                alwaysExpanded={true}
            />
        </>
    );
};

OfferDecryptionProgress.propTypes = {};

const mapStateToProps = state => {
    return {
        rfxOfferDecryptionStatus: state.resources[RfxOfferService.RESOURCE_ID_RFX_OFFER_DECRYPTION_STATUS]
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OfferDecryptionProgress);
